<script lang="ts">
  import { MenuLink } from "@getprovi/craft";
  import { markAsSeen } from "@retailer/services/user_notifications_service";

  import { EventTracking } from "@shared/services/event_tracking/events";
  import { NotificationClickEntity } from "@shared/services/event_tracking/entities";
  import moment from "moment";

  import type { UserNotification } from "@shared/types/UserNotification";

  import CurrentUserStore from "@shared/svelte/Stores/CurrentUserStore";

  export let notification: UserNotification;
  export let updateSeenMessages: (id: number) => void;
  export let toggleDrawer: (() => void) | undefined;
  export let setMessage: ((id: UserNotification) => void) | undefined;

  const { trackEvent } = EventTracking;

  const handleClick = async event => {
    event.preventDefault();

    setMessage?.(notification);

    trackEvent(
      "notification_clicked",
      new NotificationClickEntity({
        type: "notification_clicked",
        notification_id: notification.id,
        was_read: !!notification.seen_at,
      }),
    );

    if (!localStorage.getItem(`ohlq_message_${notification.id}_${$CurrentUserStore.id}_seen`)) {
      localStorage.setItem(
        `ohlq_message_${notification.id}_${$CurrentUserStore.id}_seen`,
        new Date().toISOString(),
      );
    }

    if (!notification.seen_at) await markAsSeen(notification);

    updateSeenMessages(notification.id);

    if (notification.action_link) {
      window.location.href = notification.action_link;
    } else {
      toggleDrawer?.();
    }
  };

  const relativeTime = moment(notification.created_at).fromNow();

  $: messageRead =
    !!notification.seen_at ||
    !!localStorage.getItem(`ohlq_message_${notification.id}_${$CurrentUserStore.id}_seen`);
</script>

<MenuLink
  href="#"
  subtitle={relativeTime}
  variant={messageRead ? "read" : "unread"}
  testId="notification-{notification.id}"
  on:click={handleClick}
>
  {#if notification.notification_type === "one_way_message"}
    <p class="text-left"><strong>Ohio Liquor - OHLQ</strong> has sent you a message.</p>
  {:else}
    {@html `${notification.description.slice(0, 256)}`}
  {/if}
</MenuLink>
